import { Print as Icon } from '@mui/icons-material';

import { Fab } from '@mui/material';
import { APPBAR_MAX_HEIGHT } from 'config/constants';
import spacing from 'lib/spacing';
import { makeStyles } from 'tss-react/mui';

interface Props {
	disabled: boolean;
}

function PrintIcon({ disabled }: Props) {
	const { classes } = useStyles();

	return (
		<Fab
			className={classes.fab}
			size="medium"
			variant="extended"
			color="primary"
			aria-label="add"
			onClick={() => !disabled}
			disabled={disabled}
		>
			<Icon className={classes.extendedIcon} />
			Imprimir
		</Fab>
	);
}

export default PrintIcon;

const useStyles = makeStyles()((theme) => ({
	fab: {
		position: 'fixed',
		[theme.breakpoints.up('sm')]: {
			top: `${APPBAR_MAX_HEIGHT - spacing(theme, 2)}px`,
			marginLeft: theme.spacing(25),
		},
		[theme.breakpoints.down('sm')]: {
			bottom: theme.spacing(8),
			right: theme.spacing(2),
		},
		transition: theme.transitions.create(['left'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		zIndex: theme.zIndex.drawer + 2,
	},
	extendedIcon: {
		marginRight: theme.spacing(1),
	},
}));
